<p-card class="p-card container">
  <h3 class="margin--top-none" i18n>Notes laissées par le conseiller</h3>
  <textarea [formControl]="form" [maxlength]="5000" rows="6" class="w-full" pInputTextarea></textarea>
</p-card>
